<!-- https://www.figma.com/file/reAk2sU4YpRajpQu2YBOHk/007%2F1.-%D0%AD%D0%BB%D0%B5%D0%BC%D0%B5%D0%BD%D1%82%D1%8B?node-id=1614%3A17&mode=dev -->
<template>
  <div
    class="promoblock"
    :style="cssVariables"
  >
    <div class="promoblock__header">
      <div class="promoblock__header-promo">
        {{ promoText }}
      </div>
      <component
        :is="attributes.logo_link ? 'TheLink' : 'div'"
        v-if="attributes.logo"
        :link="attributes.logo_link"
        :target="attributes.logo_link ? '_blank' : undefined"
        class="promoblock__header-logo-wrapper"
      >
        <TheContent
          v-for="item of attributes.logo"
          :key="item.id"
          :elem="item"
        />
      </component>
    </div>

    <div class="promoblock__content">
      <TheContent
        v-for="item of children"
        :key="item.id"
        :elem="item"
      />
    </div>

    <TheLink
      v-if="attributes.button_link && attributes.button_label"
      :link="attributes.button_link"
      :title="attributes.button_label"
      :target="!isHomeLink(attributes.button_link) && '_blank'"
      class="promoblock__button"
    >
      {{ attributes.button_label }}
    </TheLink>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import TheContent from '~/components/content/TheContent';
  import TheLink from '~/components/TheLink.vue';
  import type { PromoBlockAttributes } from '~/types/components/PromoBlock';
  import { isHomeLink } from '~/utils';

  export default defineNuxtComponent({
    name: 'PromoBlock',

    components: {
      TheContent,
      TheLink,
    },

    props: {
      elem: {
        type: Object as PropType<TContent<PromoBlockAttributes>>,
        required: true,
      },
    },

    computed: {
      cssVariables(): Record<string, string> {
        return {
          '--block-color': this.attributes.border_color,
        };
      },

      promoText(): string {
        return this.attributes.is_ad ? 'Реклама' : 'Промо';
      },

      attributes(): PromoBlockAttributes {
        return this.elem.attributes;
      },

      children(): TContent[] {
        return this.elem.children;
      },
    },

    methods: {
      isHomeLink,
    },
  });
</script>

<style lang="scss" scoped>
  .promoblock {
    margin: 24px 0px;
    padding: 24px 16px 32px;
    border: 1px solid var(--block-color);
    border-radius: 2px;

    @include tablet {
      padding: 24px 24px 32px;
    }

    &__content {
      margin-top: 16px;

      & > :first-child {
        margin-top: 0;
      }

      & > :last-child {
        margin-bottom: 0;
      }
    }

    &__button {
      @include normalText;

      display: block;
      width: fit-content;
      text-align: center;
      min-height: 48px;

      border-radius: 2px;
      padding: 12px 54px;
      margin: 16px auto 0px;

      background-color: var(--block-color);
      color: #fff;

      font-weight: 700;
      text-decoration: none;

      @include hover {
        filter: brightness(0.9);
      }
    }

    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;

      &-logo {
        &-wrapper {
          height: 24px;

          img {
            height: 24px;
            width: auto;
            max-width: unset !important;
          }
        }
      }

      &-promo {
        @include smallText;

        color: #5c5c5c;
        font-weight: 400;
      }
    }
  }
</style>
